
















































































































import { RadialStripe, Color, ScreenIndicator } from '@/lib'
import ColorPicker from '@/components/ColorPicker.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import Randomcolor from 'randomcolor'
import Axios from 'axios'
import RandomColor from 'randomcolor'

@Component({
  components: {
    ColorPicker,
    Draggable,
  },
})
export default class ControlComponent extends Vue {
  @Prop() private preview!: RadialStripe
  @Prop() private indicator!: ScreenIndicator
  detail = false

  created() {
    this.detail = !!window.localStorage.getItem('detail')
  }

  @Watch('detail')
  onDetailChanged() {
    window.localStorage.setItem('detail', this.detail ? '1' : '')
  }

  toggleDetail() {
    this.detail = !this.detail
  }

  reset() {
    this.preview.colors = new RadialStripe().colors
  }

  random() {
    const len = Math.floor(Math.random() * (4 - 2 + 1) + 2)
    const newColors: Color[] = []
    for (let i = 0; i < len; i++) { newColors.push(new Color(RandomColor())) }
    this.preview.colors.splice(0, this.preview.colors.length, ...newColors)
  }

  get colorAddable() {
    return this.preview.colors.length < 4
  }

  get colorRemovable() {
    return this.preview.colors.length > 2
  }

  addColor() {
    this.preview.colors.push(new Color(Randomcolor()))
  }

  removeColor(i: number) {
    this.preview.colors.splice(i, 1)
  }
}
